import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Fun404Page = () => {
  const location = useLocation();
  const [funnyMessage, setFunnyMessage] = useState('');
  const [emoji, setEmoji] = useState('🤔');

  const funnyMessages = [
    "Oops! This link seems to have gone on vacation 🏖️",
    "404: Link not found. Maybe it's hiding behind your couch? 🛋️",
    "This link is playing hide and seek... and winning! 🙈",
    "We looked everywhere, but this link is more lost than my car keys 🔑",
    "Error 404: This link has left the building 🏢",
    "This URL is taking a coffee break ☕",
    "Link not found. Did you try turning it off and on again? 🔌",
    "This link went to buy cigarettes and never came back 🚬",
    "Houston, we have a problem... this link doesn't exist 🚀",
    "This link is in another castle 🏰",
    "404: Link is on a permanent vacation in the Bermuda Triangle 🌊",
    "This link has commitment issues and decided to disappear 💔"
  ];

  const emojis = ['🤔', '😅', '🤷‍♂️', '🔍', '🤖', '👻', '🦄', '🎯', '🌟', '🎪'];

  useEffect(() => {
    // Pick a random funny message and emoji
    const randomMessage = funnyMessages[Math.floor(Math.random() * funnyMessages.length)];
    const randomEmoji = emojis[Math.floor(Math.random() * emojis.length)];
    setFunnyMessage(randomMessage);
    setEmoji(randomEmoji);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const shortCode = location.pathname.replace('/', '');

  const suggestions = [
    "Double-check the URL for typos",
    "Ask the person who shared this link if they made a mistake",
    "Try searching for what you were looking for",
    "Go back and start over",
    "Take a deep breath and count to ten 🧘‍♂️"
  ];

  return (
    <div className="fun-404-container">
      <div className="fun-404-content">
        <div className="emoji-animation">{emoji}</div>

        <div className="error-code">404</div>

        <h1>Whoops! Link Not Found</h1>

        <div className="funny-message">
          {funnyMessage}
        </div>

        {shortCode && (
          <div className="attempted-link">
            <p>You tried to visit: <code>/{shortCode}</code></p>
          </div>
        )}

        <div className="suggestions">
          <h3>Here's what you can try:</h3>
          <ul>
            {suggestions.map((suggestion, index) => (
              <li key={index}>{suggestion}</li>
            ))}
          </ul>
        </div>

        <div className="action-buttons">
          <button
            className="btn-primary"
            onClick={() => window.location.href = 'https://trialconnx.com'}
          >
            🏠 Go to TrialConnx
          </button>
          <button
            className="btn-secondary"
            onClick={() => window.history.back()}
          >
            ← Go Back
          </button>
        </div>

        <div className="fun-fact">
          <p>🤓 <strong>Fun Fact:</strong> The term "404" comes from Room 404 at CERN, where the original web servers were located!</p>
        </div>
      </div>

      <style jsx>{`
        .fun-404-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          padding: 20px;
        }

        .fun-404-content {
          background: white;
          padding: 40px;
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          text-align: center;
          max-width: 600px;
          width: 100%;
        }

        .emoji-animation {
          font-size: 80px;
          margin-bottom: 20px;
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-20px);
          }
          60% {
            transform: translateY(-10px);
          }
        }

        .error-code {
          font-size: 120px;
          font-weight: 700;
          background: linear-gradient(135deg, #667eea, #764ba2);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1;
          margin-bottom: 20px;
        }

        h1 {
          font-size: 32px;
          color: #333;
          margin-bottom: 20px;
          font-weight: 600;
        }

        .funny-message {
          font-size: 20px;
          color: #555;
          line-height: 1.5;
          margin-bottom: 30px;
          padding: 20px;
          background: #f8f9fa;
          border-radius: 12px;
          border-left: 4px solid #667eea;
        }

        .attempted-link {
          background: #ffe6e6;
          padding: 15px;
          border-radius: 8px;
          margin-bottom: 25px;
          border: 1px solid #ffcccc;
        }

        .attempted-link p {
          margin: 0;
          color: #d63384;
          font-weight: 500;
        }

        .attempted-link code {
          background: #fff;
          padding: 4px 8px;
          border-radius: 4px;
          font-family: 'Monaco', 'Menlo', monospace;
          color: #d63384;
          border: 1px solid #ffcccc;
        }

        .suggestions {
          text-align: left;
          background: #e8f5e8;
          padding: 20px;
          border-radius: 12px;
          margin-bottom: 30px;
          border: 1px solid #d4edda;
        }

        .suggestions h3 {
          margin-top: 0;
          margin-bottom: 15px;
          color: #155724;
          font-size: 18px;
        }

        .suggestions ul {
          margin: 0;
          padding-left: 20px;
        }

        .suggestions li {
          margin-bottom: 8px;
          color: #155724;
          line-height: 1.4;
        }

        .action-buttons {
          display: flex;
          gap: 15px;
          justify-content: center;
          margin-bottom: 30px;
        }

        .btn-primary,
        .btn-secondary {
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          border: none;
          text-decoration: none;
        }

        .btn-primary {
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
        }

        .btn-secondary {
          background: #f8f9fa;
          color: #495057;
          border: 1px solid #dee2e6;
        }

        .btn-secondary:hover {
          background: #e9ecef;
          transform: translateY(-2px);
        }

        .fun-fact {
          background: #fff3cd;
          padding: 15px;
          border-radius: 8px;
          border: 1px solid #ffeaa7;
          font-size: 14px;
        }

        .fun-fact p {
          margin: 0;
          color: #856404;
        }

        @media (max-width: 768px) {
          .fun-404-content {
            padding: 30px 20px;
          }

          .error-code {
            font-size: 80px;
          }

          h1 {
            font-size: 24px;
          }

          .funny-message {
            font-size: 18px;
          }

          .action-buttons {
            flex-direction: column;
          }

          .btn-primary,
          .btn-secondary {
            width: 100%;
          }

          .suggestions {
            text-align: center;
          }

          .suggestions ul {
            text-align: left;
          }
        }
      `}</style>
    </div>
  );
};

export default Fun404Page;